/*
 * Copyright (C) 2019 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import {gql} from '@apollo/client'
import {shape, string} from 'prop-types'

export const MediaSource = {
  fragment: gql`
    fragment MediaSource on MediaSource {
      height
      src: url
      type: contentType
      width
    }
  `,

  shape: shape({
    height: string,
    src: string,
    type: string,
    width: string,
  }),
}

// NOTE: For the overrides here, they have to be performed on the actual
//       graphql type instead of the alias, ie `contentType` instead of `type`
export const DefaultMocks = {
  MediaSource: () => ({
    contentType: 'video/mp4',
    height: '360',
    width: '632',
  }),
}
